import FormInputRadioGeneric from './component.jsx'

export default FormInputRadioGeneric
